
import React from 'react';

const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      title: 'Health Assessment',
      description: 'Comprehensive evaluation of your health goals, medical history, and current symptoms to determine the best IV therapy for your needs.',
      icon: 'ri-clipboard-line'
    },
    {
      number: '02',
      title: 'Treatment Selection',
      description: 'Choose from our extensive menu of IV formulations or work with our team to create a custom blend tailored to your specific goals.',
      icon: 'ri-medicine-bottle-line'
    },
    {
      number: '03',
      title: 'Comfortable Treatment',
      description: 'Relax in our comfortable treatment rooms while receiving your IV therapy. Most treatments take 30-90 minutes depending on the formulation.',
      icon: 'ri-hospital-line'
    },
    {
      number: '04',
      title: 'Immediate Benefits',
      description: 'Experience the immediate effects of 100% bioavailable nutrients as they enter your bloodstream and begin optimizing your cellular function.',
      icon: 'ri-flashlight-line'
    },
    {
      number: '05',
      title: 'Progress Monitoring',
      description: 'Track your response to treatment and adjust future IV therapies based on your results and evolving health goals.',
      icon: 'ri-line-chart-line'
    },
    {
      number: '06',
      title: 'Ongoing Wellness',
      description: 'Develop a regular IV therapy schedule to maintain optimal nutrient levels and support your long-term health and wellness goals.',
      icon: 'ri-calendar-check-line'
    }
  ];

  return (
    <section className="py-16 lg:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 lg:mb-6">
            Your <strong>IV Therapy</strong> Experience
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Our streamlined process ensures you receive the most effective IV therapy in a comfortable, professional environment.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
          {steps.map((step, index) => (
            <div key={index} className="flex items-start space-x-4 lg:space-x-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-gradient-to-r from-orange-600 to-orange-700 rounded-2xl flex items-center justify-center">
                  <i className={`${step.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <div className="flex-1">
                <div className="flex items-center mb-2">
                  <span className="text-sm font-bold text-orange-600 bg-orange-100 px-3 py-1 rounded-full mr-3">
                    {step.number}
                  </span>
                  <h3 className="text-xl lg:text-2xl font-bold text-gray-900">
                    {step.title}
                  </h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 lg:mt-16 bg-white rounded-2xl p-6 lg:p-8 shadow-lg">
          <div className="grid lg:grid-cols-3 gap-6 lg:gap-8 text-center">
            <div>
              <div className="text-2xl lg:text-3xl font-bold text-orange-600 mb-2">30-90 Min</div>
              <div className="text-gray-600">Treatment Duration</div>
            </div>
            <div>
              <div className="text-2xl lg:text-3xl font-bold text-orange-600 mb-2">100%</div>
              <div className="text-gray-600">Bioavailability</div>
            </div>
            <div>
              <div className="text-2xl lg:text-3xl font-bold text-orange-600 mb-2">Immediate</div>
              <div className="text-gray-600">Results</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
